module.exports = __webpack_public_path__ + "img/Body-block_small.115c1f9a.png";